style= require('./players.styl')

sporty-seasons(
  season=season,
  blank="<unassigned players>",
  (change:season)=this.changeSeason(e)
)

.players
  .player
    .team Team
    .position Position
    .shirt Shirt
    .name Name
  each player, $index in this.sortedPlayers()
    .player(data-player=player._id class={odd: $index % 2, saved: player.$justSaved})
      .team
        select(
          name="team",
          tabindex=1,
          (blur)=this.saveTeam(player, e))
          option(selected=!player.team value="" label="<n/a>")
          each team in this.sortedTeams()
            option(
              selected=(player.team && player.team._id == team._id)
              value=team._id
            )= team.name
      .position
        select(
          name="position",
          tabindex=2,
          (blur)=this.savePosition(player, e))
          option(selected=!player.position disabled label="<position>")
          each position in positions
            option(selected=(player.position == position))= position
      .shirt #
        input(
          name="shirt",
          tabindex=3,
          type="number",
          step="1",
          value=player.shirt,
          (blur)=this.saveShirt(player, e))
      .name= player.fullName

